    <div *ngIf="course$ | async as course">
    <div class="banner-area style-two">
        <div class="container">
            <div class="banner-area-inner">
                <div class="row">
                    <div class="col-xl-8 col-lg-10">
                        <div class="banner-inner">
                            <h2>{{ course.name }}</h2>
                            <p>{{ course.overview }}</p>
                            <div class="row mt-3">                                
                                <div class="col-lg-2 col-md-3 col-sm-6 mb-3 mb-md-0">
                                    <p>Course Level</p>
                                    <p>Beginner</p>
                                </div>
                                <div *ngFor="let fact of course.facts" class="col-md-2 col-sm-6 mb-3 mb-md-0">
                                    <p>{{ fact.name }}</p>
                                    <p>{{ fact.value }}</p>
                                </div>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- banner end -->

    <!-- course details start -->
    <div class="course-details-inner">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 mt-5">
                    <div class="dmne-tab-inner style-two text-center">
                        <ul class="nav nav-tabs" id="ex1" role="tablist">
                            <li class="nav-item" role="presentation">
                                <a class="nav-link active" id="ex1-tab-1" data-toggle="pill" href="#ex1-tabs-1" role="tab" aria-selected="true">Overview</a>
                            </li>                            
                        </ul>
                    </div>
                    <div class="tab-content text-left" id="ex1-content">
                        <div class="tab-pane fade show active" id="ex1-tabs-1" role="tabpanel">
                            <div class="review-tab-inner">
                                <p>{{ course.overview }}</p>
                                <h4 class="mt-3">What you’ll learn</h4>
                                <div class="row">
                                    <div class="col-lg-6">
                                        <ul class="dmne-list-inner">
                                            <li>How to introduce yourself</li>
                                            <li>Greeting people</li>
                                            <li>Respond to introductions</li>
                                            <li>Talk about where you are from</li>
                                            <li>Talk about the weather</li>
                                            <li>Use expressions 'see you later' / 'good-bye'</li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-6">
                                        <ul class="dmne-list-inner">
                                            <li>Order a taxi</li>
                                            <li>Ask time of day</li>
                                            <li>Know how to buy food and bargain</li>
                                            <li>Ask for a table in a restaurant</li>
                                            <li>Order a meal in a restaurant</li>
                                        </ul>
                                    </div>
                                </div>                                                                 
                            </div>
                        </div>                        
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="course-view-sitebar">
                        <div class="widget widget-video-inner text-center">
                            <div class="thumb">
                                <img [src]="course.image" alt="img">                               
                            </div>
                            <div class="details pl-3 pr-3">                                
                                <div class="btn-wrap">                                    
                                    <button class="btn btn-white w-100" *ngIf="!isEnrolled" (click)="enroll(course._id)">Enroll Now</button>
                                    <a class="btn btn-white w-100" *ngIf="isEnrolled" [href]="courseUrl">Resume Course</a>
                                </div>
                                <h4 class="mt-3">This course includes</h4>
                                <ul>
                                    <li *ngFor="let include of course.includes">{{ include }}</li>                                    
                                </ul>
                            </div>
                        </div>
                        <div class="widget widget-accordion-inner p-0">
                            <h5 class="widget-title">Lesson List</h5>
                            <div class="faq-accordion accordion" id="faq_accordion">
                                <div *ngFor="let item of course.modules; let i = index" class="card">
                                    <div class="card-header">
                                        <button class="btn" data-toggle="open" data-target="'item'+{{i}}"><b>{{ item.name }}</b> - {{ item.subject }}<i class="fa fa-plus"></i><i class="fa fa-minus"></i></button>
                                    </div>
                                    <div id="'item'+{{i}}" class="open" data-parent="#faq_accordion">
                                        <div class="card-body">
                                            <ul>
                                                <li *ngFor="let unit of item.units">
                                                    <label class="single-select-inner">
                                                        <!--<input type="checkbox" />
                                                        <span class="fa fa-check"></span>-->
                                                        <b>{{ unit.name }}</b> - <i>{{ unit.audioHours }}</i>
                                                        <ul>
                                                            <li *ngFor="let learnItem of unit.learn">
                                                                - {{ learnItem.item }}
                                                            </li>
                                                        </ul>
                                                    </label>
                                                </li>                                                
                                            </ul>   
                                        </div>
                                    </div>
                                </div>                                
                            </div>  
                        </div>                        
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- course details end -->
</div>